// TODO AFTER RELEASE: move this to common constants
export const TOP_HEADERS_OFFSET_FOR_HORIZONTAL_NAV_SCROLL = 85 + 64 + 24
export const NAV_HORIZONTAL_OFFSET = 64;

// if you change `HEADER_OFFSET` remember to change it in `HEADER_OFFSET_TAILWIND_CLASS` as well
// this is because tailwindcss can't evaluate dynamic styles because it builds on runtime.
export const HEADER_OFFSET = 84;
export const HEADER_OFFSET_TAILWIND_CLASS = `top-[84px]` as const
